var app = {};
module['exports'] = app;
app.name = require("./name");
app.version = require("./version");
app.author = require("./author");



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en/app/index.js
// module id = 1177
// module chunks = 0